import { useTranslation } from 'next-i18next';
import * as yup from 'yup';

import { useApprovals } from '@/modules/settings/approvals/components/shared/logic';
import { IApprovals } from '@/modules/settings/approvals/types';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';
import PartialListWithTooltip from '@/shared/components/molecules/PartialListWithTooltip';

import Location from '~/images/shared/Location.svg';
import NotesIcon from '~/images/shared/message.svg';
import TypeIcon from '~/images/shared/note.svg';
import FieldsIcon from '~/images/shared/picture-frame.svg';
import InstanceTypeIcon from '~/images/shared/tracker.svg';

export const useTechnicalApprovals = () => {
  const { t } = useTranslation();

  const { addApproverSchema } = useApprovals();

  const getCardDetils = (
    data: IApprovals.IGetApprovalPathDetails
  ): IIconWithTitleDescriptionProps[] => {
    return [
      {
        icon: <Location width='24' height='24' />,
        title: t('location'),
        description: data.location,
      },
      {
        icon: <InstanceTypeIcon width='24' height='24' />,
        title: t('job-type'),
        description: data.jobType,
      },
      {
        icon: <TypeIcon width='24' height='24' />,
        title: t('type'),
        description: data.approvalPathTypes,
      },
      {
        icon: <FieldsIcon width='24' height='24' />,
        title: t('fields'),
        description: data?.fields ? (
          <PartialListWithTooltip
            items={data.fields.map((field) => ({
              description: field.fieldName,
            }))}
          />
        ) : (
          '-'
        ),
      },
      {
        icon: <NotesIcon width='24' height='24' />,
        title: t('notes'),
        description:
          data?.approvalPathNotes && data?.approvalPathNotes !== 'undefined'
            ? data.approvalPathNotes
            : '-',
      },
    ];
  };

  const validationCreateApprovalPathSchema = (isFarm: boolean) =>
    yup.object().shape({
      name: yup
        .string()
        .max(
          100,
          t('this-field-not-accept-more-than-x-character', { count: 100 })
        )
        // .matches(/^[a-zA-Z0-9_.-]*$/, t('this-field-is-char-and-nums-only'))
        .required(t('this-field-is-required')),
      entityId: yup.number().required(t('this-field-is-required')),
      approvalPathTypeId: yup.number().required(t('this-field-is-required')),
      approvalPathJobOrderTypeId: yup
        .number()
        .required(t('this-field-is-required')),
      cropsIds: yup
        .array()
        .of(yup.number())

        .when([], {
          is: () => isFarm,
          then: yup
            .array()
            .required(t('this-field-is-required'))
            .min(1, t('choose-at-least-one-element')),
          otherwise: yup.array().notRequired(),
        }),
      approvalPathFields: yup
        .array()
        .of(yup.number())
        .min(1, t('choose-at-least-one-element'))
        .required(t('this-field-is-required')),
      notes: yup
        .string()
        .max(
          500,
          t('this-field-not-accept-more-than-x-character', { count: 500 })
        ),
      approvers: yup
        .array()
        .of(addApproverSchema.required(t('this-field-is-required')))
        .required(t('this-field-is-required'))
        .min(1, t('this-field-is-required')),
    });

  return {
    getCardDetils,
    validationCreateApprovalPathSchema,
  };
};
